import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC, useMemo } from 'react';
import { useVoice } from '../../contexts/VoiceContext';
import { VoiceModalAudioTranscript } from './VoiceModalAudioTranscript';

interface VoiceModalErrorViewProps {
  playbackProgress: number;
  isPlaying: boolean;
  onPlayback: () => void;
}

export const VoiceModalErrorView: FC<VoiceModalErrorViewProps> = ({
  playbackProgress,
  isPlaying,
  onPlayback,
}) => {
  const { voiceError, transcript, recordedWaveform } = useVoice();
  const waveformBars = useMemo(
    () => (recordedWaveform.length > 0 ? recordedWaveform : Array(48).fill(0.2)),
    [recordedWaveform]
  );
  const hasAudioOrTranscript = waveformBars.length > 0 || transcript;

  return (
  <>
    {hasAudioOrTranscript && (
    <Box
      sx={{
        background: 'transparent',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '14px',
        p: 1.5,
        mb: 1.75,
      }}
    >
      <VoiceModalAudioTranscript
        transcript={transcript}
        waveformBars={waveformBars}
        playbackProgress={playbackProgress}
        isPlaying={isPlaying}
        onPlayback={onPlayback}
      />
    </Box>
    )}
    <Box
      sx={{
        mb: 1.75,
        p: 1.25,
        borderRadius: 14,
        background: 'color-mix(in srgb, var(--tg-theme-destructive-text-color) 12%, transparent)',
        border: '1px solid color-mix(in srgb, var(--tg-theme-destructive-text-color) 35%, transparent)',
        maxHeight: 200,
        overflow: 'auto',
      }}
    >
      <Text
        style={{
          fontSize: 12,
          fontFamily: 'monospace',
          color: 'var(--tg-theme-destructive-text-color)',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
        }}
      >
        {voiceError ?? ''}
      </Text>
    </Box>
  </>
  );
};
